import React, {useEffect, useState} from "react";
import Header from "../../../layout/header";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import NotFoundData from "../../../../Images/no-data-found.webp"
import {toast} from "react-toastify";
import CallLogsDetails from "../CallLogsDetails";
import Camera from "react-html5-camera-photo";

const Penalty = ({
                     getInactiveFsesRequest,
                     tollById,
                     getInactiveFsesResponse = [],
                     tollView = [],
                     match,
                     callLogsResponse = [],
                     callLogsRequest,
                     tollPendingMeetingResponse = [],
                     tollPendingMeetingRequest,
                     documentUploadUrlPublic,
                     documentUrlDataPublic,
                     nearestPlazaFromOperatorLocationRequest,
                     nearestPlazaFromOperatorLocationResponse = []
                 }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [phoneNo, setPhoneNo] = useState(0);
    const [list, setList] = useState([]);
    const [selfie, setSelfies] = useState([])
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [isActiveScheduled, setIsActiveScheduled] = useState(false);


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            if (parseInt(window.localStorage.toll_id) !== parseInt(match?.params?.id)) {
                delete window.localStorage.inactive_fse;
                delete window.localStorage.fse_inventory;
                delete window.localStorage.fse_tag_transfer;
                delete window.localStorage.penalty;
                delete window.localStorage.active_fse_percentage;
                delete window.localStorage.fse_inventory_percentage;
                delete window.localStorage.fse_tag_transfer_percentage;
                delete window.localStorage.penalty_percentage;
                delete window.localStorage.fse_tag_transfer_selfie;
                delete window.localStorage.penalty_selfie;
                delete window.localStorage.fse_inventory_selfie;
                delete window.localStorage.inactive_fse_selfie;
                delete window.localStorage.is_inactive_fse_tab;
                delete window.localStorage.fse_inventory_tab;
                delete window.localStorage.penalty_percentage_tab;
                delete window.localStorage.fse_tag_transfer_tab;
            }

            window.localStorage.toll_id = match?.params?.id;
            window.localStorage.penalty_percentage_tab = true;
            await tollById(match?.params?.id);
            await tollPendingMeetingRequest(match?.params?.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            if(tollView?.data?.latitude) {
                await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'penalty');
            }
            setIsLoading(false);
        })();
    }, [tollView]);

    useEffect(() => {
        if(tollPendingMeetingResponse?.data && parseInt(tollPendingMeetingResponse?.data?.status)  === 1){
            // toast.warn("No meeting is scheduled on this toll");
            // setTimeout(() => {
            //     window.location.href='fast-tag-toll-list'
            // }, 1000)
            setIsActiveScheduled(true)
        }
    }, [tollPendingMeetingResponse]);

    useEffect(() => {
        if (getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.operator_penalty_list && getInactiveFsesResponse?.data?.operator_penalty_list.length > 0) {
            setList(getInactiveFsesResponse?.data?.operator_penalty_list)
            if(window.localStorage.penalty && JSON.parse(window.localStorage.penalty).length > 0){
                setList(JSON.parse(window.localStorage.penalty))
                if(window.localStorage.penalty_selfie){
                    setSelfies(JSON.parse(window.localStorage.penalty_selfie))
                }
            } else {
                window.localStorage.penalty = JSON.stringify(getInactiveFsesResponse?.data?.operator_penalty_list)
                window.localStorage.penalty_selfie = [];
            }
        } else if (getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.operator_penalty_list && getInactiveFsesResponse?.data?.operator_penalty_list.length === 0) {
            if(window.localStorage.penalty){
                let penalty = JSON.parse(window.localStorage.penalty);
                if(penalty && Object.keys(penalty).length > 0){
                    setList(penalty)
                }
            } else {
                window.localStorage.penalty = [];
                window.localStorage.penalty_selfie = [];
            }
        } else if(getInactiveFsesResponse?.data === undefined && !window.localStorage.penalty){
            window.localStorage.penalty = [];
            window.localStorage.penalty_selfie = [];
        }
    }, [getInactiveFsesResponse]);

    // const checkNotAtToll = async (phoneNo) => {
    //     const callLogs = await CallLogsDetails();
    //     if(callLogs.length > 0){
    //         let data = {call_log: callLogs, fse_phone_no: phoneNo}
    //         setIsLoading(true)
    //         setPhoneNo(phoneNo)
    //         await callLogsRequest(data)
    //         setIsLoading(false)
    //     } else {
    //         toast.error("Need permission for call or you haven't not connected with fse!")
    //     }
    // }

    useEffect(() => {
        if (parseInt(callLogsResponse?.status) === 200) {
            markFseActive()
            toast.success("Action is saved!")
        } else if (parseInt(callLogsResponse?.status) !== 200) {
            toast.error(callLogsResponse?.message)
        }
    }, [callLogsResponse]);


    const markFseActive = (phone_no = '') => {
        let activeFse = JSON.parse(window.localStorage.penalty);
        let count = 0;
        let phone = phone_no ? phone_no : phoneNo;
        if (activeFse) {
            activeFse.map((val, i) => {
                if (parseInt(val?.user_phone) === parseInt(phone)) {
                    activeFse[i]['is_active'] = true;
                }

                if (val?.is_active) {
                    count++;
                }
            });
            window.localStorage.penalty = JSON.stringify(activeFse);
            window.localStorage.penalty_percentage = (count * 100) / activeFse.length
            window.location.reload();
        }
    }

    const handleCloseConfirmationModal = () => setOpen(false);
    const handleOpenConfirmationModal = (index, phone_np) => {
        setOpen(true)
        setIndex(index)
        setPhoneNo(phone_np)
    }

    useEffect(() => {
        if(documentUrlDataPublic?.file_url){
            if(!selfie[index]){
                selfie[index] = {};
            }
            selfie[index]['selfie'] = documentUrlDataPublic?.file_url;
            selfie['phone_no'] = phoneNo;
            selfie['is_kt_given'] = true;
            setPhoneNo('')
            setSelfies(selfie)
            markFseActive(phoneNo)
            window.localStorage.penalty_selfie = JSON.stringify(selfie)
        }
    }, [documentUrlDataPublic]);


    const checkNotAtToll = async (operatorId, plazaId, phoneNo, i) => {
        console.log(operatorId)
        // const callLogs = await CallLogsDetails();
        setIsLoading(true);
        setPhoneNo(phoneNo)
        await nearestPlazaFromOperatorLocationRequest(operatorId, plazaId);
        setIsLoading(false);
        if(!selfie[i]){
            selfie[i] = {not_at_toll: true, phone_no: phoneNo}
        }
        window.localStorage.penalty_selfie = JSON.stringify(selfie)
        setSelfies(selfie)
        // if(callLogs.length > 0){
        //     let data = {call_log: callLogs, fse_phone_no: phoneNo}
        //     setIsLoading(true)
        //     await callLogsRequest(data)
        //     setIsLoading(false)
        // } else {
        //     toast.error("Need permission for call or you haven't not connected with fse!")
        // }
    }

    useEffect(() => {
        // check call logs
        if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) === 200){
            markFseActive()
            toast.success("Action is saved!")
        } else if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) !== 200){
            toast.error(nearestPlazaFromOperatorLocationResponse?.message)
        }
    }, [nearestPlazaFromOperatorLocationResponse]);

    const notMyFse = (phoneNo, i) => {
        setIsLoading(true);
        if(!selfie[i]){
            selfie[i] = {not_my_fse: true, phone_no: phoneNo}
        }

        setSelfies(selfie)
        toast.success("Successfully marked");
        markFseActive(phoneNo, false)
        window.localStorage.penalty_selfie = JSON.stringify(selfie)
        setIsLoading(false);
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Selfie</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {handleCloseConfirmationModal()}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {selfie[index]?.selfie ?
                                        <img alt="selfie"
                                             src={selfie[index]?.selfie}/>
                                        :
                                        <Camera
                                            idealFacingMode={'user'}
                                            idealResolution={{
                                                width: 600,
                                                height: 480
                                            }}
                                            onTakePhoto={(dataUri) => {
                                                (async () => {
                                                    setIsLoading(true)
                                                    await documentUploadUrlPublic({ base_64_file: dataUri })
                                                    setIsLoading(false)
                                                })()
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={"Penalty"}/>
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {list && list.length > 0 &&
                                list.map((val, i) => {
                                    return (
                                        <>
                                            <div className="card">
                                                <div className="card-header" style={{
                                                    backgroundColor: "#473381",
                                                    color: "white"
                                                }}>{val?.user_name}</div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="mb-0 bg-white">
                                                            <div className="card-body">
                                                                <div className="user">
                                                                    <div className="row">
                                                                        <div className="col-md-12 float-field ">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-user"
                                                                                value={
                                                                                    val?.user_phone
                                                                                }
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Phone No:<i className=""></i>
                                                                            </label>
                                                                        </div>

                                                                        {isActiveScheduled &&
                                                                            <>
                                                                                {val?.penalty_details_list && val?.penalty_details_list.length > 0 &&
                                                                                    <>
                                                                                        {val?.penalty_details_list[0] && val?.penalty_details_list[0]?.UGLY_ISSUANCE && val?.penalty_details_list[0] && val?.penalty_details_list[0]?.UGLY_ISSUANCE
                                                                                            && val?.penalty_details_list[0]?.UGLY_ISSUANCE?.penalty_count &&
                                                                                            <div
                                                                                                className="col-md-12 float-field ">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    value={
                                                                                                        val?.penalty_details_list[0]?.UGLY_ISSUANCE?.penalty_count
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    Ugly Count:<i
                                                                                                    className=""></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        {val?.penalty_details_list[0] && val?.penalty_details_list[0]?.UGLY_ISSUANCE
                                                                                            && val?.penalty_details_list[0]?.UGLY_ISSUANCE?.penalty_amount &&
                                                                                            <div
                                                                                                className="col-md-12 float-field ">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    value={
                                                                                                        val?.penalty_details_list[0]?.UGLY_ISSUANCE?.penalty_amount
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    Ugly Amount:<i
                                                                                                    className=""></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        {val?.penalty_details_list[1] && val?.penalty_details_list[1]?.URT
                                                                                            && val?.penalty_details_list[1]?.URT?.penalty_count &&
                                                                                            <div
                                                                                                className="col-md-12 float-field ">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    value={
                                                                                                        val?.penalty_details_list[1]?.URT?.penalty_count
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    URT Count:<i
                                                                                                    className=""></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        {val?.penalty_details_list[1] && val?.penalty_details_list[1]?.URT
                                                                                            && val?.penalty_details_list[1]?.URT?.penalty_amount &&
                                                                                            <div
                                                                                                className="col-md-12 float-field ">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    value={
                                                                                                        val?.penalty_details_list[1]?.URT?.penalty_amount
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    className="large-label float-lb">
                                                                                                    URT Amount:<i
                                                                                                    className=""></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                {selfie[i]?.selfie ?
                                                                                    <div
                                                                                        className="col-md-12 float-field mt-2">
                                                                                        <a href={selfie[i]?.selfie}
                                                                                           target="_blank"
                                                                                           className="btn btn-info"
                                                                                           style={{width: "100%"}}
                                                                                           data-dismiss="modal"
                                                                                           aria-label="Close">Selfie</a>
                                                                                    </div>
                                                                                    :
                                                                                    <div
                                                                                        className="col-md-12 float-field mt-2">
                                                                                        <button
                                                                                            className="btn btn-primary"
                                                                                            data-toggle="modal"
                                                                                            data-target="#exampleModalCenter"
                                                                                            style={{width: "100%"}}
                                                                                            onClick={() => {
                                                                                                handleOpenConfirmationModal(i, val?.user_phone)
                                                                                            }}
                                                                                            disabled={val?.is_active}
                                                                                        >KT Given
                                                                                        </button>
                                                                                    </div>
                                                                                }
                                                                                <div className="col-md-12 float-field ">
                                                                                    <button
                                                                                        className="btn btn-primary mt-2 text-center"
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            checkNotAtToll(val?.operator_id_list[0], getInactiveFsesResponse?.data?.plaza_id, val?.user_phone, i)
                                                                                        }}
                                                                                        disabled={val?.is_active}
                                                                                    >Check FSE Not at Toll
                                                                                    </button>
                                                                                </div>
                                                                                <div className="col-md-12 float-field ">
                                                                                    <button
                                                                                        className="btn btn-primary mt-2 text-center"
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            notMyFse(val?.user_phone, i)
                                                                                            // checkNotAtToll(val?.user_phone)
                                                                                        }}
                                                                                        disabled={val?.is_active}
                                                                                    >Not My FSE
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            {list.length === 0 &&
                                <>
                                    <img src={NotFoundData} className="not-found-data" alt={""}/>
                                    <p className="text-center">Low inventory operator not found</p>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
};
export default Penalty;
